// Analytics hooks — provider intentionally not installed yet.
// Wire these events to the approved analytics provider when one is chosen.
export const EVENTS = {
  pricingPageView: "pricing_page_view",
  pricingMonthlySelected: "pricing_monthly_selected",
  pricingAnnualSelected: "pricing_annual_selected",
  pricingTrialCtaClicked: "pricing_trial_cta_clicked",
  pricingDownloadCtaClicked: "pricing_download_cta_clicked",
  pricingFaqOpened: "pricing_faq_opened",
  launchNotifySubmitted: "launch_notify_submitted",
};

export const trackEvent = (name, props = {}) => {
  if (typeof window !== "undefined" && window.console) {
    console.debug("[coacher-analytics]", name, props);
  }
};
